import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AIIndexIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-280 0)">
      <g>
        <path
          d="M243.441 243.441 152.15 243.441 152.15 730.322 243.441 730.322"
          stroke="currentColor"
          strokeWidth="45.6451"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M730.322 243.441 821.612 243.441 821.612 730.322 730.322 730.322"
          stroke="currentColor"
          strokeWidth="45.6451"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M387.983 334.731C387.983 355.738 370.953 372.768 349.946 372.768 328.938 372.768 311.908 355.738 311.908 334.731 311.908 313.723 328.938 296.693 349.946 296.693 370.953 296.693 387.983 313.723 387.983 334.731Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M524.919 334.731C524.919 355.738 507.889 372.768 486.881 372.768 465.874 372.768 448.844 355.738 448.844 334.731 448.844 313.723 465.874 296.693 486.881 296.693 507.889 296.693 524.919 313.723 524.919 334.731Z"
          stroke="currentColor"
          strokeWidth="45.6451"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M661.854 334.731C661.854 355.738 644.824 372.768 623.817 372.768 602.809 372.768 585.779 355.738 585.779 334.731 585.779 313.723 602.809 296.693 623.817 296.693 644.824 296.693 661.854 313.723 661.854 334.731Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M387.983 486.881C387.983 507.889 370.953 524.919 349.946 524.919 328.938 524.919 311.908 507.889 311.908 486.881 311.908 465.874 328.938 448.844 349.946 448.844 370.953 448.844 387.983 465.874 387.983 486.881Z"
          stroke="currentColor"
          strokeWidth="45.6451"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M524.919 486.881C524.919 507.889 507.889 524.919 486.881 524.919 465.874 524.919 448.844 507.889 448.844 486.881 448.844 465.874 465.874 448.844 486.881 448.844 507.889 448.844 524.919 465.874 524.919 486.881Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M661.854 486.881C661.854 507.889 644.824 524.919 623.817 524.919 602.809 524.919 585.779 507.889 585.779 486.881 585.779 465.874 602.809 448.844 623.817 448.844 644.824 448.844 661.854 465.874 661.854 486.881Z"
          stroke="currentColor"
          strokeWidth="45.6451"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M387.983 639.032C387.983 660.039 370.953 677.069 349.946 677.069 328.938 677.069 311.908 660.039 311.908 639.032 311.908 618.024 328.938 600.994 349.946 600.994 370.953 600.994 387.983 618.024 387.983 639.032Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M524.919 639.032C524.919 660.039 507.889 677.069 486.881 677.069 465.874 677.069 448.844 660.039 448.844 639.032 448.844 618.024 465.874 600.994 486.881 600.994 507.889 600.994 524.919 618.024 524.919 639.032Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
        <path
          d="M661.854 639.032C661.854 660.039 644.824 677.069 623.817 677.069 602.809 677.069 585.779 660.039 585.779 639.032 585.779 618.024 602.809 600.994 623.817 600.994 644.824 600.994 661.854 618.024 661.854 639.032Z"
          stroke="currentColor"
          strokeWidth="45.6451"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
          transform="matrix(1 0 0 1.00001 153.791 -120.651)"
        />
      </g>
    </g>
  </Icon>
);
